import { render, staticRenderFns } from "./CmgRadioButton.vue?vue&type=template&id=7868f2da&scoped=true&lang=pug&"
import script from "./cmg-radio-button.ts?vue&type=script&lang=ts&"
export * from "./cmg-radio-button.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRadioButton.vue?vue&type=style&index=0&id=7868f2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7868f2da",
  null
  
)

export default component.exports